import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

/** @jsx jsx */
import { forwardRef, useCallback } from 'react';
import { ClassNames, jsx } from '@emotion/core';
import Avatar, { ACTIVE_SCALE_FACTOR, BORDER_WIDTH } from '@atlaskit/avatar';
import { B300, B400, B50, background, N20, N30, N30A, N500 } from '@atlaskit/theme/colors';
var FONT_SIZE = {
  xsmall: 10,
  small: 10,
  medium: 11,
  large: 12,
  xlarge: 16,
  xxlarge: 16
};

var getButtonStyles = function getButtonStyles(css, _ref) {
  var size = _ref.size,
      isActive = _ref.isActive;
  var activeStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    transform: scale(", ");\n    box-shadow: 0 0 0 ", "px ", ";\n    color: ", ";\n  "])), B50, ACTIVE_SCALE_FACTOR, BORDER_WIDTH, B300, B400);
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    font-size: ", "px;\n    font-family: inherit;\n    font-weight: 500;\n\n    &:hover {\n      background-color: ", ";\n      &:after {\n        background-color: ", ";\n      }\n    }\n\n    &:active {\n      ", "\n      &:after {\n        background-color: transparent;\n      }\n    }\n\n    ", "\n  "])), N500, N20, FONT_SIZE[size], N30, N30A, activeStyles, isActive && activeStyles);
};

var MAX_DISPLAY_COUNT = 99;
var MoreIndicator = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var _ref2$appearance = _ref2.appearance,
      appearance = _ref2$appearance === void 0 ? 'circle' : _ref2$appearance,
      _ref2$borderColor = _ref2.borderColor,
      borderColor = _ref2$borderColor === void 0 ? background() : _ref2$borderColor,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size,
      _ref2$count = _ref2.count,
      count = _ref2$count === void 0 ? 0 : _ref2$count,
      testId = _ref2.testId,
      onClick = _ref2.onClick,
      ariaControls = _ref2['aria-controls'],
      ariaExpanded = _ref2['aria-expanded'],
      ariaHaspopup = _ref2['aria-haspopup'],
      _ref2$buttonProps = _ref2.buttonProps,
      buttonProps = _ref2$buttonProps === void 0 ? {} : _ref2$buttonProps,
      isActive = _ref2.isActive;
  var onClickHander = useCallback(function (event, analyticsEvent) {
    if (buttonProps.onClick) {
      buttonProps.onClick(event);
    }

    onClick(event, analyticsEvent);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [buttonProps.onClick, onClick]);
  return jsx(Avatar, {
    appearance: appearance,
    size: size,
    borderColor: borderColor,
    ref: ref,
    onClick: onClickHander
  }, function (_ref3) {
    var _ = _ref3.testId,
        className = _ref3.className,
        ref = _ref3.ref,
        props = _objectWithoutProperties(_ref3, ["testId", "className", "ref"]);

    return jsx(ClassNames, null, function (_ref4) {
      var css = _ref4.css,
          cx = _ref4.cx;
      return jsx("button", _extends({}, buttonProps, props, {
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        className: cx(className, getButtonStyles(css, {
          size: size,
          isActive: isActive
        }))
      }), "+", count > MAX_DISPLAY_COUNT ? MAX_DISPLAY_COUNT : count);
    });
  });
});
MoreIndicator.displayName = 'MoreIndicator';
export default MoreIndicator;